@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerLocationRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerSelectionRepository
import kotlinx.coroutines.flow.Flow

interface DeleteInspectionUseCase {
    operator fun invoke(inspectionId: String, deleteLocalOnly: Boolean = false): Flow<FlowResult<Unit>>
}

expect class DeleteInspectionUseCaseImpl(
    inspectionRepository: InspectionRepository,
    templateRepository: TemplateRepository,
    answerRepository: AnswerRepository,
    answerFileRepository: AnswerFileRepository,
    answerLocationRepository: AnswerLocationRepository,
    answerSelectionRepository: AnswerSelectionRepository,
) : DeleteInspectionUseCase {
    override fun invoke(inspectionId: String, deleteLocalOnly: Boolean): Flow<FlowResult<Unit>>
}
